// AI 검수 — 서버 메뉴(/api/users/menus)에 없고 아래 채널에서만 노출하는 화면.
// 사이드바 주입(libs/core/Layout)과 라우트 가드(AppLayout/DefaultLayout)가 **같은 기준**을 봐야 한다.
// 한쪽만 알면 메뉴는 보이는데 눌러도 /blank 로 튕긴다.
export const AI_DESIGN_REVIEW_PATH = '/aiDesignReview';
export const AI_RESOURCE_REVIEW_PATH = '/aiResourceReview';

/** 「디자인 관리」 하위에 끼워 넣는 메뉴 — 순서대로 노출된다 */
export const AI_REVIEW_MENUS: readonly { id: string; url: string; title: string }[] = [
  { id: 'aiDesignReview', url: AI_DESIGN_REVIEW_PATH, title: 'AI 디자인 검수' },
  { id: 'aiResourceReview', url: AI_RESOURCE_REVIEW_PATH, title: 'AI 리소스 검수' },
];

const AI_REVIEW_CHANNEL_IDS: readonly string[] = ['ohprintme', 'snaps'];

export const isAiReviewChannel = (channelId?: string): boolean =>
  !!channelId && AI_REVIEW_CHANNEL_IDS.includes(channelId);

/** 서버 메뉴에 없어도 이 채널에서는 통과시켜야 하는 경로인가 */
export const isChannelOnlyMenuPath = (pathname: string, channelId?: string): boolean =>
  isAiReviewChannel(channelId) && AI_REVIEW_MENUS.some((menu) => pathname.startsWith(menu.url));
